import React from 'react';
import { Components, Theme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';

export const MuiAlertIconMapping = {
  primary: <ErrorIcon />,
  secondary: <HelpIcon />,
  error: <ErrorIcon />,
  warning: <WarningIcon />,
  success: <CheckCircleIcon />,
  info: <InfoIcon />,
};

export const MuiAlert = {
  defaultProps: {
    iconMapping: MuiAlertIconMapping,
    severity: 'primary',
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      borderRadius: 4,
      color: theme.palette[ownerState.severity!].onContainer,
      backgroundColor: theme.palette[ownerState.severity!].container,
      padding: theme.spacing(2),
      boxSizing: 'border-box',
    }),
    outlined: ({ theme, ownerState }) => ({
      borderColor: theme.palette[ownerState.severity!].outline,
    }),
    message: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flex: 1,
      padding: 0,

    },
    icon: {
      padding: 0,
    }
  },
} as Components<Theme>['MuiAlert'];
